import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = string[];

export const useDefaultObservableStringArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectStringArray extends BehaviorSubject<CurrentType> {}
